var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoughnut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4251_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.845 130.802C156.022 142.348 147.121 152.059 136.125 158.864C125.129 165.668 112.467 169.301 99.5361 169.362C86.6053 169.422 73.9094 165.907 62.8508 159.205C51.7921 152.503 42.8009 142.875 36.8703 131.384C30.9398 119.894 28.3005 106.987 29.2441 94.0907C30.1877 81.1943 34.6775 68.8095 42.2175 58.3044C49.7575 47.7992 60.0543 39.5825 71.9707 34.5616C83.8871 29.5408 96.9593 27.9113 109.744 29.853L99.2095 99.21L161.845 130.802Z",
    fill: "url(#paint0_linear_4251_2092)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4251_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.891 29.8755C120.832 31.5611 131.22 35.8123 140.204 42.2817C149.188 48.751 156.513 57.2547 161.58 67.0975C166.648 76.9403 169.314 87.8427 169.361 98.9134C169.408 109.984 166.834 120.909 161.85 130.794L99.2095 99.21L109.891 29.8755Z",
    fill: "url(#paint1_linear_4251_2092)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4251_2092",
    x: 19.2353,
    y: 24.147,
    width: 160.85,
    height: 168.366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.20914,
    dy: 9.11981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.01524
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.027451 0 0 0 0 0.027451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4251_2092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4251_2092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4251_2092",
    x: 89.3886,
    y: 24.9643,
    width: 98.2133,
    height: 128.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.20914,
    dy: 9.11981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.01524
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.027451 0 0 0 0 0.027451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4251_2092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4251_2092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4251_2092",
    x1: 198.42,
    y1: 99.21,
    x2: 99.2095,
    y2: -0.000487276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4251_2092",
    x1: 198.42,
    y1: 99.21,
    x2: 99.2095,
    y2: -0.000487276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56CCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoughnut);
export default __webpack_public_path__ + "static/media/Doughnut.4558324bc55b7cd3d7fe39277a9467bb.svg";
export { ForwardRef as ReactComponent };